<template>
  <div>
    <!-- 内容 -->
    <div class="page-content-box">
      <div class="filling-list-title">
        <div class="page-title-item">变更时间</div>
        <div class="page-title-item">变更内容</div>
        <div class="page-title-item">操作</div>
      </div>
      <div class="filling-content-list" v-for="(item, index) in tableData" :key="index">
        <div class="filling-content-date">{{ getCreateTime(item.createTime) }}</div>
        <div class="filling-content-txt">
          <div class="filling-txt-title">{{ item.operateType | operateType }}</div>
          <!-- 变更等级 -->
          <p v-show="item.operateType == 6">
            <span>客户等级：</span>由【{{
              transform(getFieldConfig('level', 'selectItemList'), item.valueOriginal)
            }}】变更为【{{ transform(getFieldConfig('level', 'selectItemList'), item.valueNew)}}】
          </p>
          <p v-show="item.operateType == 6"><span>预计生效时间：</span>{{ item.alterExecTimePlan | getDateSFM }}</p>
          <p v-show="item.operateType == 6"><span>实际生效时间：</span>{{ item.alterExecTime | getDateSFM }}</p>
          <!-- 变更基础资料 -->
          <p v-show="[2,4,7].includes(item.operateType)"><span>变更字段：</span>{{ getFieldName(item.alterFieldDesc) }}</p>
          <!--  导入资料 || 新增资料 -->
          <p v-if="getBizState(item.valueOriginal, item.valueNew, 'bizState') !== '暂无'">
            <span>业务状态：
              <span>
                  {{ getBizState(item.valueOriginal, item.valueNew, 'bizState') }}
              </span>
            </span>
          </p>
          <p v-if="getMaintainStaff(item.valueOriginal, item.valueNew, 'maintainStaff') !== '暂无'">
            <span>负责人员：
              <span>
                {{ getMaintainStaff(item.valueOriginal, item.valueNew, 'maintainStaff') }}
              </span>
            </span>
          </p>
          <p v-if="getStaffName(item.valueOriginal, item.valueNew, item.operateType) !== '暂无'">
            <el-popover
              placement="top-start"
              title="业务指派人员"
              width="700"
              trigger="hover"
              :open-delay="400"
              :content="getStaffName(item.valueOriginal, item.valueNew, item.operateType)">
              <span slot="reference" class="text-overflow">
                业务指派人员：{{ getStaffName(item.valueOriginal, item.valueNew, item.operateType) }}
              </span>
            </el-popover>
          </p>
          

          <p><span>变更人：</span>{{ item.staffName }} - {{ item.staffMobileNo }}</p>
          <p><span>变更入口：</span>{{ item.appSideName }}</p>
        </div>
        <div class="filling-content-detail" @click="toDetail(item)"><span>查看当前资料</span></div>
      </div>
      <div class="no-data" style="text-align: center" v-show="tableData && tableData.length == 0">暂无数据</div>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  props:{
    page:{ // 人员组织列表
      type: Object,
      default: {},
    },
    path : {
      type:String,
      default: ''
    },
    tableData:{ // 变更列表
      type: Array,
      default: [],
    }
  },
  data() {
    return {
    };
  },
  created() {
    
  },
  computed: {
    configName() {
      return this.$route.query.configName
    }
  },
  methods: {
    getCreateTime(createTime) {
      let time = '-'
      if (createTime) {
        let index = createTime.lastIndexOf(':')
        time = index !== -1 ? createTime.substring(0,index) : createTime
      }
      return time
    },
    //列表
    getData(param) {
      this.$emit('getData',param)
    },
    //获取字段名称
    getFieldName(val) {
      if (val) {
        let nameList = [];
        let list = JSON.parse(val);
        if (list && list.length > 0) {
          list.forEach((i) => {
            nameList.push(i.fieldDesc);
          });
          return nameList.join('、');
        }
      } else {
        return '-';
      }
    },
    //获取配置下拉选项
    transform(list, val) {
      var name = '暂无等级';
      let data = JSON.parse(val);
      if (list && list.length > 0 && data && data.level) {
        list.forEach((item) => {
          if (data.level == item.value) {
            name = item.text ||'无';
          }
        });
      }
      return name;
    },
    //获取配置对应字段
    getFieldConfig(params, key) {
      if (!localStorage.getItem(this.configName)) return
      var fieldList = JSON.parse(localStorage.getItem(this.configName)).fieldList;
      var newConfig = {};
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return newConfig && newConfig[key];
    },
    //获取指派人员名称
    getStaffName(valueOriginal, valueNew, type) {
      let name = '暂无';
      if (valueOriginal || valueNew) {
        let belongStaffOriginal = valueOriginal && JSON.parse(valueOriginal).belongStaff ? (typeof JSON.parse(valueOriginal).belongStaff === 'string' ? JSON.parse(JSON.parse(valueOriginal).belongStaff) : JSON.parse(valueOriginal).belongStaff) :  null;
        let belongStaffNew = valueNew && JSON.parse(valueNew).belongStaff ? (typeof JSON.parse(valueNew).belongStaff === 'string' ? JSON.parse(JSON.parse(valueNew).belongStaff) : JSON.parse(valueNew).belongStaff) :  null;
        if (belongStaffOriginal || belongStaffNew) {
          name = !belongStaffOriginal
            ? this.setStaffName(belongStaffNew)
            : `由【${this.setStaffName(belongStaffOriginal)}】变更为【${this.setStaffName(belongStaffNew)} 】`;
        }
      }
      return name;
    },
    getMaintainStaff(valueOriginal, valueNew,key) {
      let name = '暂无';
      if (valueOriginal || valueNew) {
        let belongStaffOriginal = valueOriginal && JSON.parse(valueOriginal)[key] ? (typeof JSON.parse(valueOriginal)[key] === 'string' ? JSON.parse(JSON.parse(valueOriginal)[key]) : JSON.parse(valueOriginal)[key]) :  null;
        let belongStaffNew = valueNew && JSON.parse(valueNew)[key] ? (typeof JSON.parse(valueNew)[key] === 'string' ? JSON.parse(JSON.parse(valueNew)[key]) : JSON.parse(valueNew)[key]) :  null;
        if (belongStaffOriginal || belongStaffNew) {
          name = !belongStaffOriginal
            ? `${belongStaffNew.staffName}-${belongStaffNew.mobileNo}`
            : `由【${belongStaffOriginal.staffName}-${belongStaffOriginal.mobileNo}】变更为【${belongStaffNew.staffName}-${belongStaffNew.mobileNo}】`;
        }
      }
      return name;
    },
    getBizState(valueOriginal, valueNew,key) {
      let name = '暂无';
      if (valueOriginal || valueNew) {
        let belongStaffOriginal = valueOriginal && JSON.parse(valueOriginal)[key] ? JSON.parse(valueOriginal)[key] :  null;
        let belongStaffNew = valueNew && JSON.parse(valueNew)[key] ? JSON.parse(valueNew)[key] :  null;
        if (belongStaffOriginal || belongStaffNew) {
          name = !belongStaffOriginal
            ? `${this.bizStateLookUp(belongStaffNew)}`
            : `由【${this.bizStateLookUp(belongStaffOriginal)}】变更为【${this.bizStateLookUp(belongStaffNew)}】`;
        }
      }
      return name;
    },
    bizStateLookUp(val) {
      if (val == '' || val == null) {
        return '-';
      } else {
        return val == 'Y' ? '启用' : '停用';
      }
    },
    setStaffName(list) {
      let arr = Array.isArray(list) ? list.map((item) => `${item.staffName}-${item.mobileNo}`) : ['无'];
      return arr.join('、');
    },
    toDetail(item) {
      this.$router.push({
        path: this.path,
        query: {
          guid: item.guid,
          createTime: item.createTime,
          configName: this.configName
        },
      });
    },

    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.getData();
    },

  },
};
</script>
<style scoped>
/* 标题 */
.page-title-box {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #d9d9d9;
}
.page-back {
  width: 60px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
}
.page-title {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
/* 内容 */
.page-content-box {
  padding: 16px;
  background: #fff;
  box-sizing: border-box;
}
.filling-list-title {
  height: 32px;
  line-height: 32px;
  display: flex;
  font-size: 12px;
  text-align: left;
  border-bottom: 1px solid #d9d9d9;
  background: #f2f2f2;
}
.page-title-item {
  padding-left: 12px;
  border-right: 1px solid #d9d9d9;
}
.page-title-item:nth-child(1),
.page-title-item:nth-child(3) {
  width: 160px;
}
.page-title-item:nth-child(2) {
  flex: 1;
}

.filling-content-list {
  display: flex;
  padding: 16px 0;
  text-align: left;
  box-sizing: border-box;
  border-left: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
}
.filling-content-date,
.filling-content-detail {
  flex-shrink: 0;
  width: 160px;
  padding-left: 12px;
}
.filling-content-date {
  color: #666666;
}
.filling-content-detail {
  color: #4fa1a4;
}
.filling-content-detail span {
  cursor: pointer;
}
.filling-content-txt {
  flex: 1;
  padding-left: 12px;
}
.filling-txt-title {
  font-size: 16px;
  color: #404040;
  margin-bottom: 10px;
}
.filling-content-txt p {
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  margin: 3px 0;
}
.filling-content-txt p span {
  flex-shrink: 0;
}
.no-data {
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
</style>
